import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'num_of_onsite_dormitories'

export const dataPointDefinition = {
  retracedId: 'num_of_onsite_dormitories',
  name: 'Number of on-site dormitories:',
  description:
    'Include all dormitories on facility premises, regardless of who lives in the dormitory and who manages the dormitory.\r\r\n\r\r\nAttach documentation (e.g., a map) showing a) location of dormitory on the facility premises/ compound; b) name of dormitory, if applicable; d) number of workers living in the dormitory. ',
  meta: {},
  fieldTypeId: 'NUMBER',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'number',
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'fp-bs-5',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 800,
  sectionId: '2.2.9.10',
  impactArea: 'Accommodation & Dormitories',
  impactAreaId: 'ACCOMODATION_AND_DORMITORIES',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
